<template>
  <div id="Statistic">
    <div>
      <div v-if="getAddr().OrganType < 3" class="pt-1">
        <!-- 页面布局 -->
        <div class="m-2 pt-1 border-radius bg-white">
          <van-row>
            <van-col span="4">
              <i class="fa fa-calendar fa-lg mt-3"></i>
            </van-col>
            <van-col span="16">
              <van-picker
                :border="true"
                :columns="examTime.array"
                :default-index="examTime.index"
                :visible-item-count="1"
                @change="onConfirm"
              />
            </van-col>
            <van-col span="4">
              <span class="fa-stack mt-1" @click="examTime.showPicker = true">
                <i class="fa fa-exchange fa-stack-1.5x"></i>
                <i class="fa fa-circle-thin fa-stack-2x"></i>
              </span>
            </van-col>
          </van-row>
        </div>
        <div class="m-2 border-radius">
          <!-- 按标签方式显示正常考试统计数据 -->
          <van-grid :fixed="false" icon-size="28px" :column-num="4" v-show="true">
            <van-grid-item icon="user-o">
              <van-icon name="friends-o" />
              <b class="text-title color-deepskyblue">
                {{
                examData.data ? examData.data.StudentNum : 0
                }}
              </b>
              <small class="color-gray">考生</small>
            </van-grid-item>
            <van-grid-item icon="label-o">
              <van-icon name="coupon-o" />
              <b class="text-title color-yellow">
                {{
                examData.data ? examData.data.JobNum : 0
                }}
              </b>
              <small class="color-gray">职位</small>
            </van-grid-item>
            <van-grid-item icon="map-marked">
              <van-icon name="cluster" />
              <b class="text-title color-red">
                {{
                examData.data ? examData.data.RoomNum : 0
                }}
              </b>
              <small class="color-gray">考场</small>
            </van-grid-item>
            <van-grid-item icon="bars">
              <van-icon name="home-o" />
              <b class="text-title color-green">
                {{
                examData.data ? examData.data.AddrNum : 0
                }}
              </b>
              <small class="color-gray">考点</small>
            </van-grid-item>
          </van-grid>
        </div>

        <div class="text-left">
          <van-tabs
            v-model="navIndex"
            :fixed="false"
            :border="false"
            background="#FEFEFE"
            color="#007aff"
            title-active-color="#007aff"
            @click="navRendered"
          >
            <!-- 考点内容 -->
            <van-tab :name="0">
              <template slot="title">
                <b>考点列表</b>
              </template>
              <div class="mt-0" v-show="showMapDiv">
                <div id="container"></div>
              </div>
              <!-- 考点数据分析内容 -->
              <van-tabs @click="switchClick">
                <van-tab v-for="(item, index) in addrinfo" :key="index" :title="item.AreaName">
                  <div class="m-2">
                    <van-cell class="border-radius">
                      <template slot="title">
                        {{ item.AreaName }}
                        <span class="color-gray">
                          考点
                          <i class="color-black">{{ item.AddrNum }}</i>个
                        </span>
                      </template>
                    </van-cell>
                  </div>
                  <div class="m-2" v-for="(e, i) in item.AddrList" :key="i">
                    <van-cell class="border-radius">
                      <template slot="title">
                        <div class="pb-1" :style="{ 'border-bottom': '1px solid #EFEFEF' }">
                          <i
                            class="fa fa-fw fa-map-marker color-blue"
                            @click="drawMap(item.AddrList, i)"
                          ></i>
                          {{ e.AddrName }}
                        </div>
                      </template>
                      <template slot="label">
                        <van-row>
                          <van-col span="12">
                            <p>
                              考生
                              <b class="color-black">{{ e.StudentNum }}</b>人
                            </p>
                            <p>
                              进行
                              <b class="color-black">
                                {{
                                e.ExamNameList.length
                                }}
                              </b>
                              场考试
                            </p>
                            <p>
                              <span
                                class="color-dodgerblue"
                                @click="showAddrExamName(e.ExamNameList)"
                              >查看场次信息</span>
                            </p>
                          </van-col>
                          <van-col span="12">
                            <p>
                              考场
                              <b class="color-black">{{ e.RoomNum }}</b>
                              间 ({{
                              e.VideoNum > 0 ? "信息化考场" : "非信息化考场"
                              }})
                            </p>
                            <p>
                              <span
                                class="color-dodgerblue"
                                @click="showAddrUser(e.OrganUserList)"
                              >工作人员{{ e.OrganUserNum }}人</span>
                            </p>
                            <p>
                              <span @click="showAddrMonitor(item)">监考人员</span>
                              <b class="color-black">{{ e.MonitorNum }}</b> 人
                            </p>
                          </van-col>
                        </van-row>
                        <p v-if="false">地址 {{ e.Address }}</p>
                      </template>
                    </van-cell>
                  </div>
                </van-tab>
              </van-tabs>
            </van-tab>
            <!-- 考生内容 -->
            <van-tab :name="1">
              <template slot="title">
                <b>考生信息</b>
              </template>
              <div class="m-2">
                <!-- 考生数据分析内容 -->
                <van-collapse v-model="studentinfo.active" class="pb-4" :border="false">
                  <van-collapse-item
                    title="考生性别统计"
                    class="item"
                    :name="0"
                    icon="friends-o"
                    v-show="studentinfo.StudentSex.length > 0"
                  >
                    <!-- 考生性别图表 -->
                    <div id="studentinfo_sex_chart" class="chart_example"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="年龄统计"
                    class="item"
                    :name="1"
                    icon="friends-o"
                    v-show="studentinfo.StudentAge.length > 0"
                  >
                    <!-- 考生年龄图表 -->
                    <div id="studentinfo_age_chart" class="chart_example_x"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="学历统计"
                    class="item"
                    :name="2"
                    icon="friends-o"
                    v-show="studentinfo.StudentExperience.length > 0"
                  >
                    <!-- 学历统计图表 -->
                    <div id="studentinfo_experience_chart" class="chart_example"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="学位统计"
                    class="item"
                    :name="3"
                    icon="friends-o"
                    v-show="studentinfo.StudentDegree.length > 0"
                  >
                    <!-- 学位统计图表 -->
                    <div id="studentinfo_degree_chart" class="chart_example"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="考生身份"
                    class="item"
                    :name="4"
                    icon="friends-o"
                    v-show="studentinfo.StudentIdentity.length > 0"
                  >
                    <!-- 考生身份图表 -->
                    <div id="studentinfo_identity_chart" class="chart_example"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="民族统计"
                    class="item"
                    :name="5"
                    icon="friends-o"
                    v-if="studentinfo.StudentNational.length > 0"
                  >
                    <!-- 名族统计图表 -->
                    <div id="studentinfo_national_chart" class="chart_example_y"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="政治面貌"
                    class="item"
                    :name="7"
                    icon="friends-o"
                    v-show="studentinfo.StudentPolitics.length > 0"
                  >
                    <!-- 政治面貌图表 -->
                    <div id="studentinfo_politics_chart" class="chart_example_y"></div>
                  </van-collapse-item>
                  <van-collapse-item
                    title="籍贯统计"
                    class="item"
                    :name="6"
                    icon="friends-o"
                    v-show="studentinfo.StudentNative.length > 0"
                  >
                    <van-cell-group
                      :title="
                        studentinfo.StudentNative.length > 0
                          ? '有' +
                            studentinfo.StudentNative.length +
                            '个省的考生报名考试'
                          : '没有考生籍贯信息'
                      "
                    >
                      <van-cell
                        :title="item.FieldName"
                        :value="item.StudentNum + '人'"
                        :label="'占比' + item.StuPercent"
                        v-for="(item, index) in studentinfo.StudentNative"
                        :key="index"
                      />
                    </van-cell-group>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </van-tab>
            <!-- 职位内容 -->
            <van-tab :name="2">
              <template slot="title">
                <b>职位统计</b>
              </template>
              <!-- 职位数据分析内容 -->
              <van-collapse v-model="jobinfo.active" class="m-2 pb-4" :border="false">
                <van-collapse-item
                  title="竞争最激烈前十职位"
                  class="item"
                  :name="0"
                  icon="notes-o"
                  v-if="jobinfo.HotJob.DataCount > 0"
                >
                  <van-cell v-for="(item, index) in jobinfo.HotJob.JobStatisList" :key="index">
                    <template slot="title"><!-- 【{{ item.AreaName }}】 -->{{ item.DeptName }} <b>{{item.JobName}}</b> [{{item.JobNo}}]</template>
                    <template slot="label">
                      <small class="ml-2">
                        招录人数 {{ item.RecruitNum }} 招录比
                        {{ item.RecruitPercent }}
                      </small>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="无人报考职位"
                  class="item"
                  :name="3"
                  icon="notes-o"
                  v-if="jobinfo.NoneStuJob.DataCount > 0"
                >
                  <van-cell v-for="(item, index) in jobinfo.NoneStuJob.JobStatisList" :key="index">
                    <template slot="title"><!-- 【{{ item.AreaName }}】 -->{{ item.DeptName }} <b>{{item.JobName}}</b> [{{item.JobNo}}]</template>
                    <template slot="label">
                      <small class="ml-2">招录{{ item.RecruitNum }}人</small>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="职位分级统计"
                  class="item"
                  :name="1"
                  icon="notes-o"
                  v-if="jobinfo.JobClassify.DataCount > 0"
                >
                  <van-cell v-for="(item, index) in jobinfo.JobClassify.JobStatisList" :key="index">
                    <template slot="title">{{ item.JobFieldName }}</template>
                    <template slot="label">
                      <small class="ml-2">
                        招录人数 {{ item.RecruitNum }} 招录比
                        {{ item.RecruitPercent }}
                      </small>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="职位分类统计"
                  class="item"
                  :name="2"
                  icon="notes-o"
                  v-if="jobinfo.JobCategory.DataCount > 0"
                >
                  <van-cell v-for="(item, index) in jobinfo.JobCategory.JobStatisList" :key="index">
                    <template slot="title">{{ item.JobFieldName }}</template>
                    <template slot="label">
                      <small class="ml-2">
                        招录人数 {{ item.RecruitNum }} 招录比
                        {{ item.RecruitPercent }}
                      </small>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="按职位分类报名考生性别"
                  class="item"
                  :name="4"
                  icon="notes-o"
                  v-if="jobinfo.JobStudentSex.DataCount > 0"
                >
                  <van-cell
                    v-for="(item, index) in jobinfo.JobStudentSex.JobStatisList"
                    :key="index"
                  >
                    <template slot="title">{{ item.JobFieldName }}</template>
                    <template slot="label">
                      <div class="text-center" v-for="(e, i) in item.FieldList" :key="i">
                        <van-divider v-if="i == 0">招录 {{ e.RecruitNum }}</van-divider>
                        {{ e.FieldName }}考生 {{ e.StudentNum }} 占比
                        {{ e.StuPercent }}
                      </div>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="按职位分类报名考生学历"
                  class="item"
                  :name="5"
                  icon="notes-o"
                  v-if="jobinfo.JobStudentExperience.DataCount > 0"
                >
                  <van-cell
                    v-for="(item, index) in jobinfo.JobStudentExperience
                      .JobStatisList"
                    :key="index"
                  >
                    <template slot="title">{{ item.JobFieldName }}</template>
                    <template slot="label">
                      <div class="text-center" v-for="(e, i) in item.FieldList" :key="i">
                        <van-divider v-if="i == 0">招录 {{ e.RecruitNum }}</van-divider>
                        {{ e.FieldName }} {{ e.StudentNum }} 占比
                        {{ e.StuPercent }}
                      </div>
                    </template>
                  </van-cell>
                </van-collapse-item>
                <van-collapse-item
                  title="按职位分类报名考生身份"
                  class="item"
                  :name="6"
                  icon="notes-o"
                  v-if="jobinfo.JobStudentIdentity.DataCount > 0"
                >
                  <van-cell
                    v-for="(item, index) in jobinfo.JobStudentIdentity
                      .JobStatisList"
                    :key="index"
                  >
                    <template slot="title">{{ item.JobFieldName }}</template>
                    <template slot="label">
                      <div class="text-center" v-for="(e, i) in item.FieldList" :key="i">
                        <van-divider v-if="i == 0">招录 {{ e.RecruitNum }}</van-divider>
                        {{ e.FieldName }} {{ e.StudentNum }} 占比
                        {{ e.StuPercent }}
                      </div>
                    </template>
                  </van-cell>
                </van-collapse-item>
              </van-collapse>
            </van-tab>
            <!-- 缺考统计 -->
            <van-tab :name="3">
              <template slot="title">
                <b>缺考统计</b>
              </template>
              <div class="m-2">
                <van-collapse v-model="realinfo.active">
                  <van-collapse-item :name="0">
                    <template slot="title">
                      <div>
                        {{
                        "本场考试共有考生" +
                        realinfo.AreaAbsentNumGet.StudentNum +
                        "人,缺考" +
                        realinfo.AreaAbsentNumGet.AbsentNum
                        }}
                      </div>
                    </template>
                    <van-grid :column-num="4">
                      <van-grid-item
                        v-for="(item, index) in realinfo.AreaAbsentNumGet
                          .AreaList"
                        :key="index"
                        class="color-blue"
                      >
                        <template slot="icon">
                          <b>{{ item.AreaName }}</b>
                          <p>
                            {{
                            100 -
                            (
                            (item.AbsentNum / item.StudentNum).toFixed(
                            4
                            ) * 100
                            ).toFixed(2)
                            }}%
                          </p>
                        </template>
                        <template slot="text">{{ item.AbsentNum }}/{{ item.StudentNum }}</template>
                      </van-grid-item>
                    </van-grid>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 弹出层 -->
        <div>
          <van-popup round v-model="examTime.showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="examTime.array"
              @cancel="examTime.showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
          <van-popup
            v-model="examData.addrShow"
            round
            closeable
            position="bottom"
            class="popup-l1"
            v-if="examData.data"
          >
            <van-nav-bar :title="examTime.array[examTime.index] + '考点'" />
            <div
              v-for="(item, index) in examData.data.AddrNumList"
              :key="index"
              class="m-2 text-left"
            >
              <van-cell-group>
                <template slot="title">
                  <van-icon name="location" class="color-black mr-1" />
                  <b class="color-black">
                    {{
                    item.AreaName + "共计 " + item.AddrNum + " 个考点"
                    }}
                  </b>
                </template>
                <van-cell v-for="(e, i) in item.AddrList" :key="i" :title="e.AddrName">
                  <template slot="label">
                    <p>
                      本场考试有
                      <b class="color-black">{{ e.RoomNum }}</b> 间考场
                      <b class="color-black">{{ e.CameraNum }}</b>个监控摄像头
                      <b class="color-black">{{ e.StudentNum }}</b> 名考生
                    </p>
                    地址位于{{ e.Address }}
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </van-popup>
          <van-popup
            v-model="examData.roomShow"
            round
            closeable
            position="bottom"
            class="popup-l1"
            v-if="examData.data"
          >
            <van-nav-bar :title="examTime.array[examTime.index] + '考场'" />
            <div
              v-for="(item, index) in examData.data.AddrRoomNumList"
              :key="index"
              class="m-2 text-left"
            >
              <van-cell-group>
                <template slot="title">
                  <van-icon name="location" class="color-black mr-1" />
                  <b class="color-black">
                    {{
                    item.AreaName + "共计 " + item.RoomNum + " 间考场"
                    }}
                  </b>
                </template>
                <van-cell center v-for="(e, i) in item.AddrRoomNumList" :key="i">
                  <van-row>
                    <van-col span="18" class="text-overflow">
                      {{
                      e.AddrName
                      }}
                    </van-col>
                    <van-col span="6">
                      考场
                      <b>{{ e.RoomNum }}</b> 间
                    </van-col>
                  </van-row>
                </van-cell>
              </van-cell-group>
            </div>
          </van-popup>
        </div>
      </div>
      <div class="p-4" v-else>
        <div class="card">
          <div class="intro">
            <!-- <img id="logo" src="../assets/logo.png" /> -->
            <i class="fa fa-thumb-tack fa-3x color-gray"></i>
            <!-- <h2>标题</h2> -->
            <p>当前岗位没有可查看统计分析项</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>统计分析数据加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "Statistic",
  data() {
    return {
      examTime: {
        data: [], //场次数据
        array: [], //考试场次控件使用数组
        index: 0, //考试场次索引变量
        showPicker: false //选择器搭配弹出层
      }, //考试场次
      examData: {
        data: {},
        addrShow: false,
        roomShow: false
      }, //考试基本数据
      navIndex: 0, // 类别导航索引变量
      addrinfo: [], // 考点基础数据
      //考生基础数据对象
      studentinfo: {
        active: [0, 1, 2, 3, 4, 5, 6, 7],
        StudentSex: [], //性别
        StudentAge: [], //年龄
        StudentExperience: [], //学历
        StudentDegree: [], //学位
        StudentNational: [], //民族
        StudentIdentity: [], //考生身份
        StudentNative: [], //籍贯
        StudentPolitics: [] //政治面貌
      },
      //职位基础数据对象
      jobinfo: {
        active: [0],
        JobClassify: [], //职位分级统计
        JobCategory: [], //职位分类统计
        HotJob: [], //竞争最激烈前十职位
        NoneStuJob: [], //无人报考职位
        JobStudentSex: [], //按职位分类报名考生性别,
        JobStudentExperience: [], //按职位分类报名考生学历,
        JobStudentIdentity: [] //按职位分类报名考生身份
      },
      realinfo: {
        active: [0],
        AreaAbsentNumGet: { StudentNum: 0, AbsentNum: 0 } //获取各考区考生缺考数
      },
      overlayshow: true, // 遮罩层
      showMapDiv: true,
      mapInstance: null // 天地图实例
    };
  },
  watch: {
    navIndex(newVal) {
      if (newVal == 0) {
        //判断导航栏切换到'考点列表(0)'时触发
      }
      if (newVal == 1) {
        //判断导航栏切换到'考点列表(1)'时触发
      }
    }
  },
  methods: {
    navRendered(val) {
      /* 导航索引切换到1(考生信息)时触发 */
      if (val == 1) {
        /* 考生性别图表 */
        setTimeout(() => {
          let sexData = [];
          this.studentinfo.StudentSex.forEach(element => {
            sexData.push({
              name: element.FieldName,
              value: [element.StudentNum]
            });
          });
          let myChart = this.$echarts.init(
            document.getElementById("studentinfo_sex_chart")
          );
          myChart.setOption(
            this.chartRPie(
              "考生性别" + this.studentinfo.StudentSex.length + "种",
              "",
              sexData
            )
          );
        }, 500);
        /* 考生年龄图表 */
        setTimeout(() => {
          let ageText = [];
          let ageData = [];
          this.studentinfo.StudentAge.forEach(element => {
            ageText.push(element.FieldName);
            ageData.push(element.StudentNum);
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_age_chart")
          );
          myChart1.setOption(
            this.echartBarX(
              "考生分" + this.studentinfo.StudentAge.length + "个年龄段",
              ageText,
              ageData
            )
          );
        }, 500);
        /* 考生学历 */
        setTimeout(() => {
          let experienceData = [];
          this.studentinfo.StudentExperience.forEach(element => {
            experienceData.push({
              value: element.StudentNum,
              name: element.FieldName
            });
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_experience_chart")
          );
          myChart1.setOption(
            this.chartRPie(
              "考生学历" + this.studentinfo.StudentExperience.length + "种",
              "",
              experienceData
            )
          );
        }, 500);
        /* 考生学位 */
        setTimeout(() => {
          let degreeData = [];
          this.studentinfo.StudentDegree.forEach(element => {
            degreeData.push({
              value: element.StudentNum,
              name: element.FieldName
            });
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_degree_chart")
          );
          myChart1.setOption(
            this.chartRPie(
              "考生学位" + this.studentinfo.StudentDegree.length + "种",
              "",
              degreeData
            )
          );
        }, 500);
        /* 考生身份 */
        setTimeout(() => {
          let identityData = [];
          this.studentinfo.StudentIdentity.forEach(element => {
            identityData.push({
              value: element.StudentNum,
              name: element.FieldName
            });
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_identity_chart")
          );
          myChart1.setOption(
            this.chartRPie(
              "考生身份" + this.studentinfo.StudentIdentity.length + "种",
              "",
              identityData
            )
          );
        }, 500);
        /* 考生民族 */
        setTimeout(() => {
          let nationalText = [];
          let nationalData = [];
          this.studentinfo.StudentNational.forEach(element => {
            nationalText.push(element.FieldName);
            nationalData.push(element.StudentNum);
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_national_chart")
          );
          myChart1.setOption(
            this.chartBarY(
              "考生民族" + this.studentinfo.StudentNational.length + "个",
              nationalText,
              nationalData
            )
          );
        }, 500);
        /* 政治面貌 */
        setTimeout(() => {
          let politicsText = [];
          let politicsData = [];
          this.studentinfo.StudentPolitics.forEach(element => {
            politicsText.push(element.FieldName);
            politicsData.push(element.StudentNum);
          });
          let myChart1 = this.$echarts.init(
            document.getElementById("studentinfo_politics_chart")
          );
          myChart1.setOption(
            this.chartBarY(
              "政治面貌" + this.studentinfo.StudentPolitics.length + "种",
              politicsText,
              politicsData
            )
          );
        }, 500);
      }
    },
    onConfirm(obj, value, index) {
      this.examTime.index = index == undefined ? value : index;
      this.ExamDataAnalysis(this.examTime.data[this.examTime.index].BeginTime); //刷新考试数据分析事件
      this.examTime.showPicker = false;
    },
    /* 考试场次 */
    async ExamDataAnalysis(datetime) {
      /* 获取考试场次基本信息 */
      await this.apiWPA_ExamDataAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          ExamTIme: datetime
        },
        this,
        res => {
          this.examData.data = res.data;
        }
      );
      /* 获取考试场次考点信息 */
      await this.apiWPA_AreaAddrNumGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          ExamTIme: this.examTime.data[this.examTime.index].BeginTime
        },
        this,
        res => {
          this.addrinfo = res.data;
          this.drawMap(res.data[0].AddrList);
        }
      );
      /* 获取各考区实时考生缺考数 */
      await this.apiWPA_AreaAbsentNumGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          ExamTIme: datetime
        },
        this,
        res => {
          // eslint-disable-next-line no-console
          // console.log("缺考统计数组", res);
          if (res.code == 20000) this.realinfo.AreaAbsentNumGet = res.data;
        }
      );
    },
    /* 切换考点 */
    switchClick(name) {
      this.drawMap(this.addrinfo[name].AddrList);
    },
    /* 地图渲染 */
    drawMap(addrlist, index) {
      if (this.mapInstance == null) {
        // 初始化天地图实例
        this.mapInstance = new T.Map("container");
      }
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      index = index || 0;
      if (addrlist.length > 0) {
        // 设置地图中心点（BD-09 → WGS-84）
        var centerCoord = this.amaplocationfrom(addrlist[index].MapCoord.split(","));
        // eslint-disable-next-line no-undef
        this.mapInstance.centerAndZoom(new T.LngLat(centerCoord[0], centerCoord[1]), 13);
        this.mapInstance.enableDrag();
        // 循环考点，添加点标记
        addrlist.forEach(element => {
          var coord = this.amaplocationfrom(element.MapCoord.split(","));
          // eslint-disable-next-line no-undef
          var lnglat = new T.LngLat(coord[0], coord[1]);
          // 创建点标记
          // eslint-disable-next-line no-undef
          var marker = new T.Marker(lnglat);
          // 创建信息窗口文本标注
          var labelContent = element.AddrName.substr(0, 4);
          // eslint-disable-next-line no-undef
          var label = new T.Label({
            text: labelContent,
            position: lnglat,
            offset: new T.Point(0, -30)
          });
          this.mapInstance.addOverLay(marker);
          this.mapInstance.addOverLay(label);
        });
      }
    },
    // 百度坐标系(BD-09)转天地图坐标系(WGS-84)
    // 转换链路: BD-09 → GCJ-02 → WGS-84
    amaplocationfrom(array) {
      var bd_lon = parseFloat(array[0]);
      var bd_lat = parseFloat(array[1]);

      // BD-09 转 GCJ-02
      var x = bd_lon - 0.0065;
      var y = bd_lat - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * Math.PI * 3000.0 / 180.0);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * Math.PI * 3000.0 / 180.0);
      var gcj_lon = z * Math.cos(theta);
      var gcj_lat = z * Math.sin(theta);

      // GCJ-02 转 WGS-84
      var a = 6378245.0;
      var ee = 0.00669342162296594323;
      var dlat = this._transformLat(gcj_lon - 105.0, gcj_lat - 35.0);
      var dlon = this._transformLon(gcj_lon - 105.0, gcj_lat - 35.0);
      var radlat = gcj_lat / 180.0 * Math.PI;
      var magic = Math.sin(radlat);
      magic = 1 - ee * magic * magic;
      var sqrtmagic = Math.sqrt(magic);
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * Math.PI);
      dlon = (dlon * 180.0) / (a / sqrtmagic * Math.cos(radlat) * Math.PI);
      var wgs_lon = gcj_lon - dlon;
      var wgs_lat = gcj_lat - dlat;

      return [wgs_lon, wgs_lat];
    },
    // GCJ-02 转 WGS-84 辅助方法 - 纬度偏移
    _transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
      return ret;
    },
    // GCJ-02 转 WGS-84 辅助方法 - 经度偏移
    _transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
      return ret;
    },
    showAddrExamName(ExamNameList) {
      let msg = "";
      ExamNameList.forEach(e => {
        msg +=
          "" +
          e.ExamName +
          "\n" +
          this.formatShortDateTime(e.BeginTime) +
          " 至 " +
          this.formatShortDateTime(e.EndTime) +
          "\n\n";
      });
      this.$dialog
        .alert({
          title: "考试详情",
          message: msg
        })
        .then(() => {
          // on close
        });
    },
    showAddrUser(item) {
      let msg = "";
      item.forEach(element => {
        if (element.ReportNum == 0) {
          msg += element.RoleNameList[0].RoleName + "\n";
          msg += "" + element.RealName + " : ";
          msg += element.DutyName ? "(" + element.DutyName + ")" : "";
          msg += element.Phone;
          msg += "\n\n";
        } else {
          msg += element.RoleNameList[0].RoleName + "\n";
          msg += element.UserCount + "人";
          msg += "\n\n";
        }
      });
      this.$dialog
        .alert({
          title: "工作人员",
          message: msg
        })
        .then(() => {
          // on close
        });
    },
    showAddrMonitor() {},
    /* 获取考生性别统计数据 */
    async apiWPA_StudentData() {
      await this.apiWPA_StudentInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID
        },
        this,
        res => {
          if (res.code == 20000) {
            /* StudentSex 性别， */
            this.studentinfo.StudentSex = res.data.StudentSex;
            /* StudentAge 年龄， */
            this.studentinfo.StudentAge = res.data.StudentAge;
            /* StudentExperience 学历， */
            this.studentinfo.StudentExperience = res.data.StudentExperience;
            /* StudentDegree 学位， */
            this.studentinfo.StudentDegree = res.data.StudentDegree;
            /* StudentIdentity 考生身份， */
            this.studentinfo.StudentNational = res.data.StudentNational;
            /* StudentNational 民族， */
            this.studentinfo.StudentIdentity = res.data.StudentIdentity;
            /* StudentNative 籍贯， */
            this.studentinfo.StudentNative = res.data.StudentNative;
            /* StudentPolitics 政治面貌 */
            this.studentinfo.StudentPolitics = res.data.StudentPolitics;
          }
        }
      );
    },
    async apiWPA_JobInfo() {
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "JobClassify"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.JobClassify = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "JobCategory"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.JobCategory = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "HotJob"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.HotJob = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "NoneStuJob"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.NoneStuJob = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "JobStudentSex"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.JobStudentSex = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "JobStudentExperience"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.JobStudentExperience = res.data;
        }
      );
      await this.apiWPA_JobInfoAnalysisGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RangeID: this.getAddr().RangeID,
          DataType: "JobStudentIdentity"
        },
        this,
        res => {
          if (res.code == 20000) this.jobinfo.JobStudentIdentity = res.data;
        }
      );
    }
  },
  created() {},
  mounted() {
    // 获取考试时间场次
    this.apiWPA_ExamTimeListGet(
      {
        WorkID: this.getWork().WorkID,
        OrganID: this.getAddr().OrganID,
        RangeID: this.getAddr().RangeID
      },
      this,
      async res => {
        this.examTime.data = res.data;
        if (res.data && res.data.length > 0) {
          res.data.forEach((element, index) => {
            // 循环考试场次添加到控件绑定数组中
            this.examTime.array.push(element.ExamNameText);
            //eslint-disable-next-line
            //console.log("场次循环", element);
            //判断当前时间是否在这个循环的场次开始时间与结束时间范围之内
            var currtime = new Date();
            //选中满足当前时间范围考试的索引
            if (
              new Date(element.BeginTime) < currtime &&
              currtime < new Date(element.EndTime)
            ) {
              this.examTime.index = index;
            }
          });
          // 获取第一场考试的考试数据
          this.ExamDataAnalysis(
            this.examTime.data[this.examTime.index].BeginTime
          );
          //获取职位数据
          await this.apiWPA_JobInfo();
          // 获取考生数据
          await this.apiWPA_StudentData();
          //获取工作任务后隐藏加载提示遮罩层
          this.overlayshow = false;
        } else {
          //获取工作任务后隐藏加载提示遮罩层
          this.overlayshow = false;
        }
      }
    );
  }
};
</script>

<style scoped>
#Statistic {
  background: #efefef;
  min-height: 700px;
}
.item {
  /*   margin: auto 5%;
  width: 90%; */
  line-height: 40px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 1px 5px #ebedf0;
}
#container {
  width: 100%;
  height: 180px;
}
.demo-preview {
  border-bottom: 0;
}
.van-grid-item__content {
  padding: 0 !important;
}
.chart_example {
  width: 100%;
  height: 170px;
  border: 0 solid red;
  margin: 0 auto;
}
.chart_example_x {
  width: 100%;
  height: 150px;
  border: 0 solid red;
  margin: 0 auto;
}
.chart_example_y {
  width: 100%;
  height: 550px;
  border: 0 solid red;
  margin: 0 auto;
}
::v-deep .tdt-logo{
    display: none !important;/* 去掉天地图logo */
}
::v-deep .tdt-left {
    display: none !important;/* 去掉天地图版权信息 */
}
</style>